import { useState, useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import Header from "../HeaderTrilhaDeConhecimento";
import { useSelector } from "react-redux";
import api from "../../services/api";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { useStyles, Container, CustomTooltip } from "./styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import LinearProgress from "@mui/material/LinearProgress";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  Collapse,
  ListItemButton,
  Tooltip,
  Typography,
  useTheme,
  useMediaQuery,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Atividade from "./ModalAtividade";
import Sidebar from "../DashboardAluno/Sidebar/Sidebar";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { CiLogout } from "react-icons/ci";
import { TrilhaProgresso } from "./TrilhaProgresso";
import { ListaAulas } from "./ListaAulas";
import { VideoSection } from "./VideoSection";
import Certificado from "./certificado";
import { Exercicios } from "./exercicios";
import { Grid } from "@mui/material";
import { padding } from "polished";
import { DownloadCertificadoButton } from "../../pages/PageTrilhaNew/Certificado";
import TrilhaConhecimento from "./TrilhaDeConhecimento";

const theme = createTheme({
  palette: {
    primary: {
      main: "#BD6F57",
      darker: "rgba(212, 109, 13, 1)",
    },
    // success: {
  },
});
const buttonStyle = {
  fontSize: "38px",
  width: "48px",
  height: "48px",
  marginRight: "20px",
  color: "white",
};

function PageTrilhaDeConhecimento() {
  const { id } = useParams();
  const history = useHistory();
  const classes = useStyles();
  const [playlistItems, setPlaylistItems] = useState([]);
  const [trilha, setTrilha] = useState({});
  const [cursos, setCursos] = useState([]);
  let profile = useSelector((state) =>
    state.user.profile.dataValues
      ? state.user.profile.dataValues
      : state.user.profile
  );
  const [openAtividade, setOpenAtividade] = useState(false);
  const [atividadeIndex, setAtividadeIndex] = useState(0);
  const [cursoId, setCursoId] = useState(false);
  const [atualiza, setAtualiza] = useState(false);
  const [loading, setLoading] = useState(true);
  const [aulas, setAulas] = useState([]);
  const [certificadoDisponivel, setCertificadoDisponivel] = useState(false);
  const [showCursos, setShowCursos] = useState(
    new Array(cursos.length).fill(false)
  );
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [videoSelecionado, setVideoSelecionado] = useState(null);
  const [videoCursoId, setVideoCursoId] = useState(null);
  const [videoIndex, setVideoIndex] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState(0);
  const [videoCompletado, setVideoCompletado] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const trilhaResponse = await api.get(`/trilhas-de-conhecimento/${id}`);
        setTrilha(trilhaResponse.data);

        const cursosResponse = await api.get(
          `/trilhas-de-conhecimento/cursos/${id}`
        );

        setCursos(cursosResponse.data);

        setLoading(false);
      } catch (error) {
        console.error("Erro ao buscar dados da API:", error);
        setLoading(false);
      }
    };

    fetchData();
    setAtualiza(false); // Reset atualiza flag
  }, [id, atualiza]);

  const handleBack = () => {
    history.push("/oxetrilhas");
  };
  const handleVideoCompletado = (videoId) => {
    setVideoCompletado(videoId);
    setAtualiza(true); // Força re-fetch dos dados
  };

  const handleChangeAba = (event, newValue) => {
    setAbaAtiva(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <Sidebar />
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          marginLeft: isMobile ? "10px" : "230px",
        }}
      >
        <Button
          onClick={handleBack}
          variant="outlined"
          style={{
            border: "none",
          }}
          aria-label="white"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              margin: "15px",
            }}
          >
            <CiLogout color="#e86225" size={23} />
            <span
              style={{
                fontSize: "17px",
                color: "#8c8c8c",
                fontFamily: "Montserrat",
              }}
            >
              Meu Histórico de Cursos
            </span>
          </div>
        </Button>
        {!isMobile && (
          <p
            style={{
              marginTop: "20px",
              fontSize: "12px",
              fontFamily: "Montserrat",
            }}
          >
            Escolha o curso:{" "}
            <span
              style={{
                fontSize: "16px",
                border: "1px solid #e86225",
                fontFamily: "Montserrat",
                padding: "10px",
                margin: "10px",
                borderRadius: "20px",
                fontWeight: "500",
              }}
            >
              {cursos[0]?.modulo?.curso?.titulo}
            </span>
          </p>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          marginLeft: isSmallScreen ? "30px" : "250px",
          padding: "10px",
          flexDirection: isMobile && "column",
        }}
      >
        <p
          style={{
            fontSize: "16px",
            fontFamily: "Montserrat",
            color: "#e86225",
          }}
        >
          Curso:{" "}
          <span
            style={{
              fontSize: "16px",
              fontFamily: "Montserrat",
              fontWeight: "bold",
              color: "#e86225",
            }}
          >
            {cursos[0]?.modulo?.curso?.titulo}
          </span>
        </p>
        <div style={{ width: isMobile ? "80%" : "30%" }}>
          {cursos.map((curso, index) => (
            <TrilhaProgresso trilha={[curso]} />
          ))}
        </div>
      </div>

      <Container maxWidth="xl" sx={{ mt: 2 }}>
        {cursos.map((curso, index) => (
          <Box key={index} display="flex" gap={4} mb={2}>
            {/* <Box width="20%" sx={{ marginLeft: "210px" }}>
              <TrilhaConhecimento curso={[curso]} />
            </Box> */}

            <Box
              width={isMobile ? "100%" : "90%"}
              sx={{ marginLeft: isMobile ? "0" : "210px" }}
            >
              <Box width="100%">
                {/* Tabs no topo */}
                <Tabs
                  value={abaAtiva}
                  onChange={handleChangeAba}
                  textColor="primary"
                  indicatorColor="#e86225"
                  sx={{ mb: 1, borderBottom: !isMobile && "1px solid #e86225" }}
                >
                  <Tab label="Vídeos" />
                  <Tab label="PDFs" />
                </Tabs>

                {abaAtiva === 0 && (
                  <Box
                    display="flex"
                    flexDirection={isMobile && "column"}
                    height={isMobile ? "750px" : "600px"}
                    width="100%"
                    gap={2}
                    sx={{
                      paddingTop: 1,
                      marginBottom: isMobile && "1rem",
                    }}
                  >
                    <Box
                      width={isMobile ? "100%" : "40%"}
                      height="100%"
                      sx={{
                        overflowY: "auto",
                        backgroundColor: "#fff",
                        borderRadius: 2,
                        paddingRight: 1,
                      }}
                    >
                      <ListaAulas
                        videoSelecionado={videoSelecionado}
                        aulas={curso.modulo.curso.playlist_items.map(
                          (aula, i) => ({
                            titulo: aula.titulo,
                            visto: curso.videos_vistos[i]?.visto,
                            videoId: aula.video_id,
                            thumbnail: aula.thumbnail,
                            descricao: aula.descricao,
                            pausado: curso.videos_vistos[i]?.pausado,
                            duracao: curso.videos_vistos[i]?.duracao,
                            onClick: () => {
                              setVideoSelecionado(aula.video_id);
                              setVideoCursoId(curso.modulo.curso.id);
                              setVideoIndex(i);
                            },
                          })
                        )}
                      />
                    </Box>

                    {/* PLAYER DE VÍDEO */}
                    <Box
                      width={isMobile ? "100%" : "60%"}
                      height="85%"
                      sx={{
                        backgroundColor: "#d3d3d3",
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {videoSelecionado &&
                      videoCursoId !== null &&
                      videoIndex !== null &&
                      cursos.length > 0 &&
                      cursos.find((c) => c.modulo.curso.id === videoCursoId) ? (
                        <VideoSection
                          videoId={videoSelecionado}
                          videoIndex={videoIndex}
                          cursoId={videoCursoId}
                          trilha={trilha}
                          modulo={
                            cursos.find(
                              (c) => c.modulo.curso.id === videoCursoId
                            )?.modulo
                          }
                          playlistItems={
                            cursos.find(
                              (c) => c.modulo.curso.id === videoCursoId
                            )?.videos_vistos || []
                          }
                          onAtualiza={() => setAtualiza(true)}
                        />
                      ) : (
                        <Box
                          height="60%"
                          minHeight="400px"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          sx={{
                            backgroundColor: "#d3d3d3",
                            borderRadius: 2,
                            color: "#fff",
                            p: 4,
                          }}
                        >
                          <Typography
                            variant="h6"
                            textAlign="center"
                            fontWeight="bold"
                          >
                            Selecione uma aula à esquerda
                          </Typography>
                          <Typography
                            variant="body2"
                            textAlign="center"
                            color="#000"
                            mt={1}
                          >
                            Clique no botão <strong>“Assistir”</strong> para
                            exibir o vídeo aqui.
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}

                {abaAtiva === 1 && (
                  <Box
                    display="flex"
                    height="600px"
                    width="100%"
                    gap={2}
                    sx={{ paddingTop: 2 }}
                  >
                    {/* LISTA DE PDFs */}
                    <Box
                      width="40%"
                      height="100%"
                      sx={{
                        overflowY: "auto",
                        backgroundColor: "#fff",
                        borderRadius: 2,
                        padding: 2,
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        Materiais PDF
                      </Typography>
                      {curso?.modulo?.curso?.pdfs?.length > 0 ? (
                        curso.modulo.curso.pdfs.map((pdf, idx) => (
                          <Box key={idx} mb={1}>
                            <a
                              href={pdf.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#e86225", fontWeight: "bold" }}
                            >
                              {pdf.nome}
                            </a>
                          </Box>
                        ))
                      ) : (
                        <Typography variant="body2">
                          Nenhum material PDF disponível.
                        </Typography>
                      )}
                    </Box>

                    {/* ÁREA DE VISUALIZAÇÃO */}
                    <Box
                      width="60%"
                      height="85%"
                      sx={{
                        backgroundColor: "#d3d3d3",
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#000",
                      }}
                    >
                      <Typography variant="body1">
                        Selecione um PDF para visualizar ou baixar.
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>

              <Box
                display="flex"
                gap={isMobile ? 0.5 : 15}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",

                  marginBottom: "5rem",
                }}
              >
                <Certificado
                  cursoConcluido={curso.atividade_concluida}
                  name={profile.name}
                  curso={curso.modulo.curso.titulo}
                  cargaHoraria={curso.modulo.trilha.carga_horaria}
                />
                <Exercicios
                  concluido={curso.atividade_concluida}
                  nota={curso.nota_atividade}
                  podeResponder={curso.curso_concluido}
                  onResponder={() => {
                    setOpenAtividade(true);
                    setCursoId(curso.modulo);
                    setAtividadeIndex(index);
                  }}
                />
              </Box>
            </Box>
          </Box>
        ))}
      </Container>

      <Atividade
        open={openAtividade}
        close={() => {
          setOpenAtividade(false);
          setAtualiza(true);
        }}
        curso={cursoId}
        trilhaId={trilha.id}
      />
    </ThemeProvider>
  );
}

export default PageTrilhaDeConhecimento;
